import { takeEvery, call, put, all } from 'redux-saga/effects';
import {
  insertUpdateItems,
  dataRequest,
  requestInProgress,
  requestFinished
} from '../../../../../../common/reducers/listsCollection/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';

function* getExecsLogsByExecId(reducerName, action) {
  // yield put(requestInProcess(reducerName));
  // let status = null;
  try {
    yield put(requestInProgress(reducerName, action.payload));
    const result = yield call(
      timeoutCall,
      TasksExecsService.getTasksExecLogListByExec,
      action.payload
    );
    if (result.response) {
      // status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateItems(reducerName, {
            itemsById: result.destructData.items,
            groupMapItemsIds: result.destructData.mapItems
          })
        );
      }
    }
    yield put(requestFinished(reducerName, action.payload));
  } catch (error) {
    console.log(error);
  }
  // yield put(requestFinished(reducerName, status));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(dataRequest(reducerName).type, getExecsLogsByExecId, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/collections/sagas/tasksExecLogCollectionSaga.js